/*
  Wspolny hover-preview swatchy dla kart .wfs-pcard (kolekcje +
  WFS Bestsellers). Delegacja zdarzen na document — dziala od razu
  dla kart doladowanych pozniej (ajax filtry/paginacja), bez
  potrzeby recznego re-init po kazdej sekcji.
*/
(function () {
  'use strict';
  if (window.__wfsPcardInit) return;
  window.__wfsPcardInit = true;

  document.addEventListener('mouseover', function (e) {
    var swatch = e.target.closest('.wfs-pcard__swatch[data-swatch-img]');
    if (!swatch) return;
    var card = swatch.closest('.wfs-pcard');
    if (!card) return;
    var mainImg = card.querySelector('.wfs-pcard__img:not(.wfs-pcard__img--alt)');
    if (!mainImg || mainImg.tagName !== 'IMG') return;

    if (card.dataset.originalSrc === undefined) {
      card.dataset.originalSrc = mainImg.getAttribute('src') || '';
      card.dataset.originalSrcset = mainImg.getAttribute('srcset') || '';
      card.dataset.originalHref = card.getAttribute('href') || '';
    }

    mainImg.removeAttribute('srcset');
    mainImg.src = swatch.dataset.swatchImg;
    if (swatch.dataset.swatchUrl) card.setAttribute('href', swatch.dataset.swatchUrl);
    card.classList.add('is-swatch-preview');
  });

  document.addEventListener('mouseout', function (e) {
    var group = e.target.closest('.wfs-pcard__swatches');
    if (!group) return;
    if (e.relatedTarget && group.contains(e.relatedTarget)) return;
    var card = group.closest('.wfs-pcard');
    if (!card || card.dataset.originalSrc === undefined) return;
    var mainImg = card.querySelector('.wfs-pcard__img:not(.wfs-pcard__img--alt)');
    if (!mainImg) return;

    mainImg.src = card.dataset.originalSrc;
    if (card.dataset.originalSrcset) mainImg.setAttribute('srcset', card.dataset.originalSrcset);
    if (card.dataset.originalHref) card.setAttribute('href', card.dataset.originalHref);
    card.classList.remove('is-swatch-preview');
  });
})();
